<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div>
      <!-- General data card-->
      <app-admin-card-with-title
        [cardTitle]="t('event.item.generalData')"
        [isContentVisible]="!isGeneralDataCollapsed" [showToggleButton]="true" [removeTopMargin]="true">
        <div class="row">
          <div class="col-12 col-xl-6">
            <div class="row">
              @if (authenticationService.isAdminstrator()) {
              <div class="col-xl pb-3">
                  <app-select formControlName="organiserId"
                              [items]="organisers" [valueKey]="'id'" [labelKey]="'name'"
                              label="app.common.organizer"/>
              </div>
              }
              <div class="col-xl pb-3">
                <app-select formControlName="measurerId" [hasDefault]="true"
                            [items]="measurers" [valueKey]="'id'" [labelKey]="'name'"
                            label="app.common.measurer"/>
            </div>
            </div>
            <div class="row pb-3">
              <div class="col-xl-6 reduce-column-right-spacing">
                <!-- Default language dropdown -->
                <app-select formControlName="defaultLanguage"
                            [items]="languages" [valueKey]="'id'" [labelKey]="'code'"
                            [labelKeyPrefix]="'app.common.language.'" label="event.item.defaultLanguage"/>
              </div>
              <!-- Additional lang-->
              <div class="col-xl-6 reduce-column-left-spacing">
                <app-multiselect-dropdown [options]="getOptions()" [formControlName]="'extraLanguages'"
                                          [dropdownLabel]="t('event.item.extraLanguage')"/>
              </div>
            </div>
            <div class="pb-3">
              <app-language-input [inputForm]="inputForm"
                                  [defaultLanguage]="inputForm.controls['defaultLanguage'].value"
                                  [extraLanguages]="inputForm.controls['extraLanguages'].value" [hrKey]="'name'"
                                  [enKey]="'nameEng'"
                                  [srKey]="'nameSr'"
                                  [bsKey]="'nameBs'"
                                  [itKey]="'nameIta'" [siKey]="'nameSlo'" [hrLabel]="'event.item.nameCro'"
                                  [enLabel]="'event.item.nameEn'"  [srLabel]="'event.item.nameSr'"   [bsLabel]="'event.item.nameBs'" [itLabel]="'event.item.nameIt'"
                                  [siLabel]="'event.item.nameSlo'"/>
            </div>
            <div class="row d-flex align-items-start">
              <div class="col-xl-9 reduce-column-right-spacing">
                <!-- League name field-->
                <app-language-input [inputForm]="inputForm"
                                    [defaultLanguage]="inputForm.controls['defaultLanguage'].value"
                                    [required]="false"
                                    [extraLanguages]="inputForm.controls['extraLanguages'].value"
                                    [hrKey]="'leagueName'"
                                    [srKey]="'leagueNameSr'"
                                    [bsKey]="'leagueNameBs'"
                                    [enKey]="'leagueNameEn'" [itKey]="'leagueNameIt'" [siKey]="'leagueNameSl'"
                                    [hrLabel]="'event.item.leagueName'"  [srLabel]="'event.item.leagueNameSr'"   [bsLabel]="'event.item.leagueNameBs'" [enLabel]="'event.item.leagueNameEn'"
                                    [itLabel]="'event.item.leagueNameIt'" [siLabel]="'event.item.leagueNameSl'"/>
              </div>
              <div class="col-xl-3 d-flex align-items-end reduce-column-left-spacing">
                <!-- Event round input -->
                <app-input type="number" formControlName="round" label="event.item.round"
                           cssClass="flex-grow-1" [min]="1" [max]="20"/>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6 ps-3 ps-xl-4">
            <app-date-time-from-to-input
              formControlName="eventDates"
              invalidMessageKey="app.common.error.range.current"
              [labelStart]="t('event.item.start.date')" [labelEnd]="t('event.item.end.date')"
            />
            <div class="row pt-3">
              <div class="col-xl-6">
                <!-- Event status dropdown -->
                <app-select formControlName="status" [items]="statuses"
                            [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'event.item.status.'"
                            label="event.item.status"/>
              </div>
              <div class="col-xl-6">
                <!-- Event type dropdown -->
                <app-select formControlName="eventType"
                            [items]="eventTypes" [valueKey]="'id'" [labelKey]="'id'" [hasDefault]="true"
                            [labelKeyPrefix]="'event.item.event.type.'" label="event.item.event.type"/>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-xl-6">
                <app-select formControlName="sportOne" [items]="sports"
                            [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'app.common.sports.'"
                            label="event.item.sport.one"/>
              </div>
              <div class="col-xl-6">
                <app-select formControlName="sportTwo" [items]="sports"
                            [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'app.common.sports.'"
                            label="event.item.sport.two"/>
              </div>

            </div>
            <div class="row pt-3">
              <div class="col-xl-6">
                <!-- Event currency dropdown -->
                <app-select formControlName="currency" [items]="currencies"
                            [valueKey]="'id'" [labelKey]="'name'" [hasDefault]="true" label="event.item.currency"/>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12">
                <div class="d-flex align-items-top mb-3">
                    <app-checkbox formControlName="commonStartNumber" [label]="t('event.item.commonStartNumber')"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="horizontal-separator mt-4 mt-3"></div>
        <div class="row">
          <div class="col-12 pt-xl-0 pt-3 d-flex flex-row">
            <div class="event-img-wrapper">
              <div class="field-title-1 mt-3">
                  <span> {{ t('app.common.upload.event.photo') }}
                    @if (inputForm.controls['imageMedium'].errors?.['required']) {
                      <span>*</span>
                    }
                  </span>
                @if (inputForm.controls['imageMedium'].touched) {
                  @for (errorMessage of inputForm.controls['imageMedium']!.errors | errorMessages:'imageMedium';track errorMessage) {
                    <span class="errorMes pt-1">{{ errorMessage }} </span>
                  }
                }
              </div>
              <div class="mt-3">
                <app-drag-and-drop [selectedFile]="inputForm.value.imageMedium" (fileChange)="imageChange($event)"
                                   [useWithCropper]="true" [cropAreaWidth]="396" [cropAreaHeight]="290" />
              </div>
            </div>
            <div class="event-logo-wrapper ms-5">
              <div class="field-title-1 mt-3">
                  <span> {{ t('app.common.upload.event.logo') }}
                    @if (inputForm.controls['imageIcon'].errors?.['required']) {
                      <span>*</span>
                    }
                  </span>
                @if (inputForm.controls['imageIcon'].touched) {
                  @for (errorMessage of inputForm.controls['imageIcon']!.errors | errorMessages:'imageIcon';track errorMessage) {
                    <span class="errorMes pt-1">{{ errorMessage }} </span>
                  }
                }
              </div>
              <div class="mt-3">
                <app-drag-and-drop [selectedFile]="inputForm.value.imageIcon" (fileChange)="logoChange($event)"
                                   [useWithCropper]="true" [cropAreaWidth]="240" [cropAreaHeight]="240"/>
              </div>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>

      <!--    Location data card-->
      <div class="mt-4">
        <app-admin-card-with-title
          [cardTitle]="t('event.item.location')"
          [isContentVisible]="!isLocationDataCollapsed" [showToggleButton]="true">
          <div class="row">
            <div class="col-12 col-xl-3">
              <div class="d-flex flex-column h-100">
                <app-input formControlName="city" label="event.item.city" cssClass="pb-3"/>
                <div class="pb-3">
                  <app-select formControlName="country" [items]="countries"
                              labelKey="id" labelKeyPrefix="app.common.country."
                              [valueKey]="'id'" [hasDefault]="true"
                              label="event.item.country"/>
                </div>
                <app-input formControlName="locationExtraTag" label="event.item.location.extra.tag"
                           cssClass="pb-3"/>
                <app-input formControlName="longitude" label="event.item.location.longitude"
                           cssClass="pb-3"/>
                <app-input formControlName="latitude" label="event.item.location.latitude"
                           cssClass="pb-3"/>
              </div>
            </div>
            <div class="col-12 col-xl-9">
              <div class="map-placeholder">
                <app-leaflet-maps-wrapper [lat]="this.inputForm.controls.latitude.value"
                                          [lng]="inputForm.controls.longitude.value"
                                          [isEraseLocationEnabled]="true" [isGetLocationEnabled]="true"
                                          [isShowLocationMarkerEnabled]="true"
                                          (onEraseLocation)="onEraseLocation()"
                                          (onSelectLocation)="onSelectLocation($event)" [positionAbsolute]="true"
                                          [defaultLanguage]="currentEventItem?.defaultLanguage"
                                          [languages]="languages"/>
              </div>
            </div>
          </div>
        </app-admin-card-with-title>
      </div>
      <app-action-buttons-row [eventPreviewVisible]="true" (onGoToEventPreview)="goToEventPreview()"
                              [eventMeasurementsVisible]="true" (onGoToEventMeasurements)="goToEventMeasurements()"
                              (onSave)="onSave()"/>
    </div>
  </form>
</ng-container>
